import { useState, useEffect, useCallback, memo } from "react";
import AnimacionCarga from "../components/animacion_de_carga";
import { obtenerClientes } from "../../functions/consultas";
import { actualizarRegistro } from "../../functions/crud";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import Swal from "sweetalert2";
import BarraSuperior from "./barra_superior";
import BotonSOS from "./sos/boton_sos";

const DIAS = [
  { key: "domingo",   label: "Domingo",    desde: "domingoDesde",   hasta: "domingoHasta" },
  { key: "lunes",     label: "Lunes",      desde: "horaInicioAtencion", hasta: "horaFinalAtencion" },
  { key: "martes",    label: "Martes",     desde: "martesDesde",    hasta: "martesHasta" },
  { key: "miercoles", label: "Miércoles",  desde: "miercolesDesde", hasta: "miercolesHasta" },
  { key: "jueves",    label: "Jueves",     desde: "juevesDesde",    hasta: "juevesHasta" },
  { key: "viernes",   label: "Viernes",    desde: "viernesDesde",   hasta: "viernesHasta" },
  { key: "sabado",    label: "Sábado",     desde: "sabadoDesde",    hasta: "sabadoHasta" },
  { key: "festivo",   label: "Festivo",    desde: "festivoDesde",   hasta: "festivoHasta" },
];

const val = (v, fb = "") => (v === null || v === undefined ? fb : String(v));

const Field = ({ label, value, onChange, type = "text", readOnly, hint }) => (
  <div style={s.fieldWrap}>
    <label style={s.label}>{label}</label>
    <input
      style={{ ...s.input, background: readOnly ? "#f5f5f5" : "#fff", color: readOnly ? "#999" : "#1a1a2e" }}
      type={type} value={value} readOnly={readOnly}
      placeholder={hint || label}
      onChange={e => onChange && onChange(e.target.value)}
    />
  </div>
);

const DiaHorario = ({ dia, estado, desde, hasta, onToggle, onDesde, onHasta }) => (
  <div style={{ ...s.diaCard, opacity: estado ? 1 : 0.55 }}>
    <div style={s.diaHeader}>
      <span style={s.diaLabel}>{dia}</span>
      <button type="button" onClick={onToggle}
        style={{ ...s.toggleBtn, background: estado ? "#2563eb" : "#d1d5db" }}>
        <div style={{ ...s.toggleKnob, transform: estado ? "translateX(20px)" : "translateX(2px)" }} />
      </button>
    </div>
    {estado && (
      <div style={s.diaInputs}>
        <div style={s.diaInputWrap}>
          <label style={s.diaInputLabel}>Desde</label>
          <input type="time" style={s.timeInput} value={desde || "07:00"}
            onChange={e => onDesde(e.target.value)} />
        </div>
        <div style={s.diaInputWrap}>
          <label style={s.diaInputLabel}>Hasta</label>
          <input type="time" style={s.timeInput} value={hasta || "17:00"}
            onChange={e => onHasta(e.target.value)} />
        </div>
      </div>
    )}
  </div>
);

const PerfilCopropiedad = memo(() => {
  const [cliente,   setCliente]   = useState(null);
  const [cargando,  setCargando]  = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile,    setLogoFile]    = useState(null);

  const [diasEstado, setDiasEstado] = useState({});
  const [diasHorario, setDiasHorario] = useState({});

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const data = await obtenerClientes();
      const nit  = localStorage.getItem("CodigoCliente");
      const entry = Object.values(data).find(c => String(c.Nit) === String(nit) || String(c.codigo) === String(nit));
      if (!entry) { setCargando(false); return; }

      setCliente(entry);
      setLogoPreview(entry.logo || null);

      const estados = {};
      const horarios = {};
      DIAS.forEach(d => {
        estados[d.key] = entry[`${d.key}Estado`] ?? true;
        horarios[`${d.key}_desde`] = parseToTime(entry[d.desde]);
        horarios[`${d.key}_hasta`] = parseToTime(entry[d.hasta]);
      });
      setDiasEstado(estados);
      setDiasHorario(horarios);
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const parseToTime = (str) => {
    if (!str || str === "null") return "07:00";
    if (/^\d{2}:\d{2}$/.test(str)) return str;
    try {
      const [time, period] = str.split(" ");
      let [h, m] = time.split(":").map(Number);
      if (period === "PM" && h !== 12) h += 12;
      if (period === "AM" && h === 12) h = 0;
      return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}`;
    } catch { return "07:00"; }
  };

  const formatTime = (t) => {
    if (!t) return "07:00 AM";
    const [h, m] = t.split(":").map(Number);
    const p = h >= 12 ? "PM" : "AM";
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${String(h12).padStart(2,"0")}:${String(m).padStart(2,"0")} ${p}`;
  };

  const update = (key, value) => setCliente(prev => ({ ...prev, [key]: value }));

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      const nit = localStorage.getItem("CodigoCliente");
      const id  = cliente.id;

      let logoUrl = cliente.logo;
      if (logoFile) {
        const ruta = `logosConjuntos/${cliente.correoElectronico}.png`;
        logoUrl = await subirArchivoFirebase(ruta, logoFile);
      }

      const payload = {
        ...cliente,
        logo: logoUrl,
        usuario: localStorage.getItem("NombreCompleto") || "",
        fecha: new Date().toISOString(),
        lunesEstado:    diasEstado.lunes,
        horaInicioAtencion: formatTime(diasHorario.lunes_desde),
        horaFinalAtencion:  formatTime(diasHorario.lunes_hasta),
        martesEstado:   diasEstado.martes,
        martesDesde:    formatTime(diasHorario.martes_desde),
        martesHasta:    formatTime(diasHorario.martes_hasta),
        miercolesEstado: diasEstado.miercoles,
        miercolesDesde: formatTime(diasHorario.miercoles_desde),
        miercolesHasta: formatTime(diasHorario.miercoles_hasta),
        juevesEstado:   diasEstado.jueves,
        juevesDesde:    formatTime(diasHorario.jueves_desde),
        juevesHasta:    formatTime(diasHorario.jueves_hasta),
        viernesEstado:  diasEstado.viernes,
        viernesDesde:   formatTime(diasHorario.viernes_desde),
        viernesHasta:   formatTime(diasHorario.viernes_hasta),
        sabadoEstado:   diasEstado.sabado,
        sabadoDesde:    formatTime(diasHorario.sabado_desde),
        sabadoHasta:    formatTime(diasHorario.sabado_hasta),
        domingoEstado:  diasEstado.domingo,
        domingoDesde:   formatTime(diasHorario.domingo_desde),
        domingoHasta:   formatTime(diasHorario.domingo_hasta),
        festivoEstado:  diasEstado.festivo,
        festivoDesde:   formatTime(diasHorario.festivo_desde),
        festivoHasta:   formatTime(diasHorario.festivo_hasta),
      };

      await actualizarRegistro(`coordi_ph_clientes/${nit}/${id}`, payload);

      Swal.fire({ title: "¡Guardado!", text: "Datos actualizados correctamente.", icon: "success", timer: 2000, showConfirmButton: false });
      setLogoFile(null);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "No se pudo guardar: " + err.message, "error");
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return <AnimacionCarga />;
  if (!cliente) return <div style={s.empty}>No se encontró información del conjunto.</div>;

  return (
    <div style={s.page}>

        <BarraSuperior></BarraSuperior>

        <br></br>
        <br></br>
        <br></br>

      <div style={s.hero}>
        <div style={s.heroInner}>
          <div style={s.logoWrap}>
            <img
              src={logoPreview || "https://via.placeholder.com/96x96?text=Logo"}
              alt="logo"
              style={s.logoImg}
            />
            <label style={s.logoEdit} title="Cambiar logo">
              <span style={{ fontSize: 14 }}>📷</span>
              <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleLogoChange} />
            </label>
          </div>
          <div>
            <h1 style={s.heroTitle}>{val(cliente.Nombre || cliente.nombre, "Conjunto")}</h1>
            <p style={s.heroSub}>{val(cliente.RazonSocial || cliente.razonSocial, "")} · NIT {val(cliente.Nit || cliente.nit)}</p>
          </div>
        </div>
        <div style={s.heroDivider} />
      </div>

      <form onSubmit={guardar} style={s.form}>

        <Section title="📋 Información general" icon="🏢">
          <div style={s.grid2}>
            <Field label="Nombre del conjunto"       value={val(cliente.Nombre || cliente.nombre)}           onChange={v => update("Nombre", v)} />
            <Field label="Razón social"              value={val(cliente.RazonSocial || cliente.razonSocial)} onChange={v => update("RazonSocial", v)} />
            <Field label="NIT"                       value={val(cliente.Nit || cliente.nit)}                 readOnly />
            <Field label="Dirección"                 value={val(cliente.Direccion || cliente.direccion)}     onChange={v => update("Direccion", v)} />
            <Field label="Ciudad"                    value={val(cliente.Ciudad || cliente.ciudad)}           onChange={v => update("Ciudad", v)} />
            <Field label="Departamento"              value={val(cliente.Departamento || cliente.departamento)} onChange={v => update("Departamento", v)} />
          </div>
        </Section>

        <Section title="📞 Contacto y administración" icon="👤">
          <div style={s.grid2}>
            <Field label="Nombre administrador"      value={val(cliente.NombreAdministrador)}  onChange={v => update("NombreAdministrador", v)} />
            <Field label="Teléfono administrador"    value={val(cliente.TelefonoAdministrador)} onChange={v => update("TelefonoAdministrador", v)} type="tel" />
            <Field label="Teléfono portería"         value={val(cliente.telefonoPorteria)}      onChange={v => update("telefonoPorteria", v)} type="tel" />
            <Field label="Teléfono auxiliar"         value={val(cliente.telefonoAuxiliar)}      onChange={v => update("telefonoAuxiliar", v)} type="tel" />
            <Field label="Correo electrónico"        value={val(cliente.correoElectronico)}     onChange={v => update("correoElectronico", v)} type="email" />
            <Field label="Correo SOS / monitoreo"   value={val(cliente.correoMonitoreo)}       onChange={v => update("correoMonitoreo", v)} type="email" />
          </div>
        </Section>

        <Section title="💰 Financiero" icon="💵">
          <div style={s.grid2}>
            <Field label="Costo administración"      value={val(cliente.costoAdmon)}   onChange={v => update("costoAdmon", v)} type="number" />
            <Field label="Enlace de pagos (sin https)" value={val(cliente.urlPagos)}   onChange={v => update("urlPagos", v)} />
          </div>
        </Section>

        <Section title="🕐 Horario de atención" icon="📅">
          <div style={s.diasGrid}>
            {DIAS.map(d => (
              <DiaHorario
                key={d.key}
                dia={d.label}
                estado={diasEstado[d.key] ?? true}
                desde={diasHorario[`${d.key}_desde`]}
                hasta={diasHorario[`${d.key}_hasta`]}
                onToggle={() => setDiasEstado(prev => ({ ...prev, [d.key]: !prev[d.key] }))}
                onDesde={v => setDiasHorario(prev => ({ ...prev, [`${d.key}_desde`]: v }))}
                onHasta={v => setDiasHorario(prev => ({ ...prev, [`${d.key}_hasta`]: v }))}
              />
            ))}
          </div>
        </Section>

        <div style={s.meta}>
          <span>Último editor: <b>{val(cliente.usuario, "—")}</b></span>
          <span>Actualización: <b>{val(cliente.fecha, "—")}</b></span>
        </div>

        <button type="submit" disabled={guardando} style={{ ...s.btn, opacity: guardando ? 0.7 : 1 }}>
          {guardando ? "Guardando…" : "💾 Guardar cambios"}
        </button>

      </form>
      <BotonSOS />
    </div>
  );
});

const Section = ({ title, children }) => (
  <div style={s.section}>
    <h3 style={s.sectionTitle}>{title}</h3>
    <div style={s.sectionBody}>{children}</div>
  </div>
);

const s = {
  page: {
    minHeight: "100vh",
    background: "#ffffff",
    fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
    paddingBottom: 60,
  },
  hero: {
    background: "#fff",
    padding: "28px 36px 0",
    borderBottom: "1px solid #f0f0f0",
    color: "#1a1a2e",
  },
  heroInner: {
    display: "flex", alignItems: "center", gap: 20, paddingBottom: 20,
    maxWidth: 960, margin: "0 auto",
  },
  logoWrap: { position: "relative", flexShrink: 0 },
  logoImg: {
    width: 80, height: 80, borderRadius: 16,
    objectFit: "cover", border: "3px solid #e5e7eb",
    background: "#f9fafb",
  },
  logoEdit: {
    position: "absolute", bottom: -6, right: -6,
    background: "#ef4444", borderRadius: "50%",
    width: 26, height: 26, display: "flex", alignItems: "center",
    justifyContent: "center", cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  },
  heroTitle: { margin: "0 0 4px", fontSize: 22, fontWeight: 700, color: "#1a1a2e" },
  heroSub:   { margin: 0, fontSize: 13, color: "#6b7280" },
  heroDivider: {
    height: 4,
    background: "linear-gradient(90deg, #ef4444, #f97316, transparent)",
    borderRadius: "4px 4px 0 0",
    maxWidth: 960,
    margin: "0 auto",
  },
  form: { maxWidth: 960, margin: "0 auto", padding: "24px 20px" },
  section: {
    background: "#fff", borderRadius: 16,
    boxShadow: "0 2px 16px rgba(37,99,235,0.07)",
    marginBottom: 20, overflow: "hidden",
  },
  sectionTitle: {
    margin: 0, padding: "16px 24px",
    fontSize: 14, fontWeight: 700, color: "#1a1a2e",
    borderBottom: "1px solid #f0f4ff",
    background: "linear-gradient(90deg,#f8faff,#fff)",
    letterSpacing: 0.3,
  },
  sectionBody: { padding: "20px 24px" },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px,1fr))",
    gap: 16,
  },
  fieldWrap: { display: "flex", flexDirection: "column", gap: 5 },
  label: {
    fontSize: 11, fontWeight: 700, color: "#6b7280",
    textTransform: "uppercase", letterSpacing: 0.5,
  },
  input: {
    padding: "10px 13px", border: "1.5px solid #e5e7eb",
    borderRadius: 10, fontSize: 14, outline: "none",
    transition: "border-color .2s", boxSizing: "border-box", width: "100%",
  },
  toggleRow: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", marginTop: 14,
    padding: "10px 0", borderTop: "1px solid #f0f4ff",
  },
  toggleLabel: { fontSize: 14, color: "#374151", fontWeight: 500 },
  toggleBtn: {
    width: 44, height: 24, borderRadius: 12, border: "none",
    cursor: "pointer", position: "relative", transition: "background .25s",
    flexShrink: 0,
  },
  toggleKnob: {
    position: "absolute", top: 2, width: 20, height: 20,
    background: "#fff", borderRadius: "50%",
    transition: "transform .25s", boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
  },
  diasGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px,1fr))",
    gap: 12,
  },
  diaCard: {
    border: "1.5px solid #e5e7eb", borderRadius: 12,
    padding: "12px 14px", transition: "opacity .2s",
  },
  diaHeader: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", marginBottom: 0,
  },
  diaLabel: { fontSize: 14, fontWeight: 600, color: "#1a1a2e" },
  diaInputs: { display: "flex", gap: 10, marginTop: 10 },
  diaInputWrap: { flex: 1, display: "flex", flexDirection: "column", gap: 4 },
  diaInputLabel: { fontSize: 10, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase" },
  timeInput: {
    padding: "7px 8px", border: "1.5px solid #e5e7eb",
    borderRadius: 8, fontSize: 13, outline: "none",
    width: "100%", boxSizing: "border-box",
  },
  meta: {
    display: "flex", gap: 24, flexWrap: "wrap",
    fontSize: 12, color: "#9ca3af", marginBottom: 16, padding: "0 4px",
  },
  btn: {
    width: "100%", padding: "15px",
    background: "linear-gradient(135deg, #c0392b, #ef4444)",
    color: "#fff", border: "none", borderRadius: 12,
    fontSize: 15, fontWeight: 700, cursor: "pointer",
    boxShadow: "0 4px 20px rgba(239,68,68,0.3)",
    transition: "opacity .2s",
  },
  empty: { textAlign: "center", padding: 60, color: "#9ca3af", fontSize: 16 },
};

export default PerfilCopropiedad;
